class HttpError extends Error {
    constructor(
        public readonly status: number,
        message: string,
        public readonly code?: string,
        public readonly body?: unknown,
    ) {
        super(message);
        this.name = 'HttpError';
    }
}

export default HttpError;
